export const FETCH_NOTIFICATION = 'FETCH_NOTIFICATION';
export const NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED';
export const DEVICE_TOKEN_SENT = 'DEVICE_TOKEN_SENT';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
